// extracted by mini-css-extract-plugin
export default {"header":"Hero_header__uY9q7","banner":"Hero_banner__6qThr"};